import { NgModule } from '@angular/core';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { DocumentConfigurationComponent } from './component/document-template-administration.component';
import { TemplateFieldDetailsComponent } from './component/template-field-details/template-field-details.component';
import { TemplateDetailsComponent } from './component/template-details/template-details.component';
import { TemplateAreaDetailsComponent } from './component/template-area-details/template-area-details.component';
import { MaterialModule } from '@sdbn/appclient';
import { CommonModule } from '@angular/common';
import { TemplatePropertiesComponent } from './component/template-properties/template-properties.component';
import { ApplicationClientCommonModule } from '@sdbn/appclient';
import { TemplateLookupEditorComponent } from './component/template-lookup-editor/template-lookup-editor.component';
import { TemplateLookupFieldsEditorComponent } from './component/template-lookup-editor/template-lookup-field-editor.component';

import { DictionaryModule } from '@sdbn/appclient';
import { CommonTranslationModule } from '@sdbn/common';



@NgModule({
  declarations: [
    TemplateAreaDetailsComponent,
    TemplateDetailsComponent,
    TemplateFieldDetailsComponent,
    DocumentConfigurationComponent,
    TemplatePropertiesComponent,
    TemplateLookupEditorComponent,
    TemplateLookupFieldsEditorComponent
  ],
  imports: [
    CommonModule,
    FormsModule,
    ReactiveFormsModule,
    MaterialModule,
    DictionaryModule,
    CommonTranslationModule,
    ApplicationClientCommonModule
  ],
  providers: []
})
export class DocumentTemplateAdministrationModule { }
